<script setup>
import SInfoMontant from '@/components/global/s-info-montant.vue'
import DetailOperationLigneAim from '@/components/fiche-aim/ligne/detail-operation-ligne-aim.vue'
</script>

<template>
  <v-expansion-panel :class="expansionPanelBgColor">
    <v-expansion-panel-header class="py-0" :disable-icon-rotate="selectable">
      <v-row no-gutters align="center">
        <v-col cols="4" align-self="center">
          <v-icon class="pr-2" :color="iconeColor">{{ icone }}</v-icon>
          {{ ligneFicheAim.poste.libelle }}
        </v-col>
        <v-col cols="8" class="text--secondary">
          <v-row no-gutters style="width: 100%" align="center">
            <v-col class="text-right pr-6" cols="4">
              <s-info-montant :montant="ligneFicheAim.montantFinal" />
            </v-col>
            <v-col class="text-right pr-6" cols="4">
              <s-info-montant :montant="montantVersementCorrespondant" />
            </v-col>
            <v-col class="text-right pr-6" cols="4">
              <s-info-montant :montant="soldeFinMois" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <template #actions v-if="selectable">
        <v-checkbox :value="estSelectionne" @click.stop="handleCheck" />
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <detail-operation-ligne-aim
        :accent="estConcerneParSelection || estConcerneParSurvol"
        :ligne-fiche-aim="ligneFicheAim"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ligne-aim-expension-panel',
  props: {
    ligneFicheAim: {
      type: Object,
      required: true,
    },
    soldes: {
      type: Array,
      required: true,
    },
    versementsDuMois: {
      type: Array,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getIconePourPosteId: 'posteAIM/getIconePourPosteAimId',
      estAjustementConcerneParAjustementSurvole: 'renduAIM_IHM_helper/estAjustementConcerneParAjustementSurvole',
      estAjustementConcerneParAjustementSelectionne:
        'renduAIM_IHM_helper/estAjustementConcerneParAjustementSelectionne',
      estPosteVersementSelectionne: 'preparationVersement_IHM_helper/estPosteVersementSelectionne',
    }),
    estSelectionne() {
      return this.estPosteVersementSelectionne(this.ligneFicheAim.poste)
    },
    estConcerneParSurvol() {
      return this.ligneFicheAim.operations.some((op) => this.estAjustementConcerneParAjustementSurvole(op.ajustementId))
    },
    estConcerneParSelection() {
      return this.ligneFicheAim.operations.some((op) =>
        this.estAjustementConcerneParAjustementSelectionne(op.ajustementId)
      )
    },
    soldeCorrespondant() {
      return this.soldes.find((value) => value.poste.posteAIMId === this.ligneFicheAim.poste.posteAIMId).montant
    },
    montantVersementCorrespondant() {
      let total = 0
      this.versementsDuMois
        .map((v) => v.lignesVersements)
        .flat()
        .filter((lv) => lv.posteAIM === this.ligneFicheAim.poste.posteAIMId)
        .forEach((lv) => (total += lv.montant))

      return total
    },
    soldeFinMois() {
      return this.soldeCorrespondant + this.ligneFicheAim.montantFinal - this.montantVersementCorrespondant
    },
    icone() {
      return this.getIconePourPosteId(this.ligneFicheAim.poste.posteAIMId)
    },
    iconeColor() {
      return this.estConcerneParSurvol || this.estConcerneParSelection ? 'secondary' : 'primary'
    },
    expansionPanelBgColor() {
      if (this.estConcerneParSelection || this.estSelectionne) {
        return 'bg-secondary-lighten-4'
      } else if (this.estConcerneParSurvol) {
        return 'bg-secondary-lighten-5'
      } else {
        return 'bg-surface-lighten-2'
      }
    },
  },
  methods: {
    ...mapActions({
      ajouterPosteAVerser: 'preparationVersement_IHM_helper/ajouterPosteAVerser',
      retirerPosteAVerser: 'preparationVersement_IHM_helper/retirerPosteAVerser',
    }),
    handleCheck() {
      if (this.estSelectionne) {
        this.retirerPosteAVerser(this.ligneFicheAim.poste)
      } else {
        this.ajouterPosteAVerser(this.ligneFicheAim)
      }
    },
  },
}
</script>

<style scoped>
.v-expansion-panel-header {
  min-height: 38px;
  padding: 0 12px;
}
</style>
